import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-notfound',
  template: `
    <div>ページが見つかりませんでした。</div>
  `,
  styles: ['div { margin-top: 20px; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NotFoundComponent {}
